import React,{useEffect,useMemo} from "react";
import css from "./LibraryScreen.module.css";
import {useParams,useNavigate} from "react-router-dom";
import {AppIcon,PluginsIntro/* ,CordovaVritraIntro */,SideBarNavigator,FeatureExplorer} from "Components";
import {libexports} from "Resources";


export default function LibraryScreen(){
    const {libname}=useParams(),navigate=useNavigate();
    const libentries=useMemo(()=>getLibEntries(libname),[libname]);
    useEffect(()=>{
        if(!libentries) navigate("/");
    },[libname]);
    return libentries&&(
        <main className={css.libraryscreen}>
            <SideBarNavigator 
                containerClassName={css.container}
                sidebarClassName={css.sidebar}
                entries={libentries}
                initialId={(libentries[0].entries?.[0]||libentries[0]).id}
            />
            <AppIcon className={css.appicon}/>
        </main>
    )
}

const statics={
    intro:{
        cordovaplugins:()=><PluginsIntro/>,
        //cordovavritra:()=><CordovaVritraIntro/>,
    },
    sectionIds:[
        "overloads","ctor",
        "returns","params","options",
        "cssvars","props","methods","properties",
    ],    
}

const getLibEntries=(libname)=>{
    let sections;
    const library=libexports[libname];
    if(library){
        const {docs}=library;
        sections=getSections(docs);
        const intro=statics.intro[libname];
        intro&&sections.unshift({id:language.introduction,renderContent:intro});
    }
    return sections;
};

const getSections=(docs)=>docs.map(entry=>{
    const {entries}=entry;
    if(entries) entry.sections=getSections(entries);
    else{
        if(!entry.name) entry.name=entry.id;
        entry.id=entry.id.toLowerCase();
        const sections=entry.sections=[];
        statics.sectionIds.forEach(key=>{
            const data=entry[key];
            if(data){
                if((key==="properties")&&!entry.methods) sections.push({
                    title:"methods & properties",
                    fields:data,
                }); else switch(key){
                    case "ctor": sections.push({title:"constructor",fields:[data]});break;
                    case "returns": sections.push({title:"return value",fields:[data]});break;
                    case "methods": sections.push({title:"methods & properties",fields:data});break;
                    default: sections.push({
                        title:key==="cssvars"?"CSS variables":key,
                        fields:data,
                    });break;
                }
            }
        });
        entry.renderContent=()=><FeatureExplorer 
            className={css.featureexplorer}
            feature={entry} 
            back={true}
        />;
    }
    return entry;
});
